import React, {FC} from "react"
import styled from "styled-components"

import {Body, H5} from "@irati/ui/src/Typography"
import Icon from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"

const Tick = styled(Flex)`
  height: 16px;
  width: 16px;
  flex-shrink: 0;
  border-radius: 100px;
  position: relative;
  top: 4px;
  background: ${({theme}) => theme.colors.tertiary.g_400};
`

interface Props {
  text: string
  isTitle?: boolean
}

const TextWithTick: FC<Props> = ({text, isTitle}) => {
  const theme = useTheme()
  const TextComp = isTitle ? H5 : Body
  return (
    <Flex gap={1} marginBottom={1}>
      <Tick justifyContent="center" alignItems="center">
        <Icon icon="tick" color={theme.colors.greys.white} size={7} />
      </Tick>
      <TextComp small color={theme.colors.primary2}>
        {text}
      </TextComp>
    </Flex>
  )
}

export default TextWithTick
